<template>
  <div class="store-setting-body">
		<div class="store-name" v-if="!isAdd">
			<span>
				<i class="el-icon-back" @click="goBack"></i>
			</span>
			<span>{{shopName}}</span>
		</div>
		<div style="display:flex;flex-direction: row;height:100%;overflow:hidden">
			<el-tabs tab-position="left" v-model="activeName"  @tab-click='routerSwitch'>
				<el-tab-pane v-for="item in urlMaps" :key="item.url" :label="item.name" :name='item.url'>
				</el-tab-pane>
			</el-tabs>
			<div style="flex:1;overflow:hidden">
				<router-view></router-view>
			</div>
		</div>
  </div>
</template>

<script>
export default {
	name: 'storeSetting',
	data () {
		return {
			activeName: 'storeInfo',
			urlMaps: [{
				name: '店铺信息',
				url: 'storeInfo'
			}, {
				name: '资质管理',
				url: 'qualification'
			}, {
				name: '授权管理',
				url: 'empower'
			}, {
				name: '店铺公告',
				url: 'shopNotice'
			}, {
				name: '关联商品',
				url: 'relatedGoods'
			}, {
				name: '关联员工',
				url: 'relatedEmployees'
			}, {
				name: '配送方式',
				url: 'deliveryWay'
			}, {
				name: '营业时间',
				url: 'closeShopTime'
			}
			// {
			// 	name: '店铺运费',
			// 	url: 'shopFreight'
			// }
			// {
			// 	name: '配送范围',
			// 	url: 'deliveryRange'
			// }, {
			// 	name: '店铺装修',
			// 	url: 'shopDecorate'
			// }
			],
			shopName: '',
			isAdd: true
		}
	},
	created () {
		this.getShopName()
		let hashArr = location.hash.split('/')
		// console.log(hashArr[hashArr.length - 1])
		this.activeName = hashArr[hashArr.length - 1]
	},
	methods: {
		goBack () {
			this.$router.push('/main/storeBasicInfo')
		},
		routerSwitch () {
			// this.$router.push(url)
			// this.active = url
			let url = this.activeName
			let storeid = sessionStorage.getItem('storeid')
			let storeInfoFlag = sessionStorage.getItem('storeInfoFlag')
			console.log(storeid, storeInfoFlag, '1111111')
			if (storeInfoFlag) {
				if (storeid && storeInfoFlag === 'true') {
					console.log(storeid, storeInfoFlag, '222222')
					this.$router.push(url)
					this.activeName = url
				} else {
					console.log(storeid, storeInfoFlag, url, '333333')
					if (url !== 'storeInfo') {
						this.$message.warning('请保存店铺信息！')
					}
				}
			} else {
				this.$router.push(url)
				this.activeName = url
			}
		},
		getShopName () {
			let shopName = window.sessionStorage.getItem('shopName')
			this.shopName = shopName
			if (window.sessionStorage.getItem('isAdd') === 'true') {
				this.isAdd = true
			} else {
				this.isAdd = false
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.store-setting-body {
	display: flex;
	flex: 1;
	min-width: 730px;
	width: 100%;
	flex-direction: column;
	overflow :hidden;
	.store-name {
		border-bottom: 1px solid #dce2fd;
		height:66px;
		min-height: 66px;
		line-height: 66px;
		box-sizing border-box
		span {
			font-size: 18px;
			font-weight: bold
			float left
			display inline-block
			line-height 66px
			padding-right 20px
			i {
				border-radius: 50%;
				cursor: pointer;
				background: #9da6af;
				padding: 3px;
			}
			.el-icon-back:before {
				content: "\E6EA";
				color: #fff;
				font-weight: bold;
			}
		}
	}
	.store-setting-header {
		width: 100px;
		border-bottom: 1px solid #dce2fd;
		// height:66px;
		// min-height: 66px;
		// line-height: 66px;
		font-size: 18px;
		box-sizing border-box
		span {
			float left
			display inline-block
			line-height 66px
			padding-right 20px
			i {
				border-radius: 50%;
				cursor: pointer;
				background: #9da6af;
				padding: 3px;
			}
			.el-icon-back:before {
				content: "\E6EA";
				color: #fff;
				font-weight: bold;
			}
		}
		li {
			margin-right 40px
			cursor pointer
			height: 100%
			box-sizing:border-box
			float left
			&.active {
				border-bottom: 3px solid var(--fx-primary-color);
				font-weight: bold
			}
		}
	}
}
</style>
<style lang="stylus">

</style>
